import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { api } from '../../Api-Endpoints/apiEndpoint';
import ApiHandler from '../../ApiHandler';
import { shallowEqual, useSelector } from 'react-redux';
import FolderTree from '../FolderTree/FolderTree';
import { useNavigate } from 'react-router-dom';

const CopyProcedureModal = ({
  showModal,
  setShowModal,
  procedure,
  getData,
}) => {
  const { folders, previousRoute } = useSelector(
    state => ({
      folders: state.Folder.folders,
    }),
    shallowEqual
  );
  const [folderId, setFolderId] = useState();

  const closeModal = () => {
    setShowModal(false);
  };

  const updateFolders = async () => {
    try {
      const { status, data } = await api.post(
        `/procedure/copy/${procedure?._id ? procedure?._id : procedure?.id}/${folderId}`,
        {
          parent: folderId,
        }
      );
      ApiHandler.getFolders();
      closeModal();
      const id = window.location.pathname.split('/').pop();
      getData(id, null);
    } catch (error) {
      console.error('Error updating folder:', error);
      // Optional: Show error feedback to the user
    }
  };

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={closeModal}
      contentLabel="Copy procedure"
      style={{
        content: {
          width: '50%',
          height: '50%',
          margin: 'auto',
          borderRadius: '20px',
          padding: 0,
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      }}
    >
      <div className="flex justify-between mx-5 my-3">
        <button onClick={closeModal}>
          <IoMdCloseCircleOutline size={20} />
        </button>
      </div>
      <hr />
      <div className="flex justify-center mx-5 my-3">
        <h2>Select targeted folder</h2>
      </div>
      <FolderTree folders={folders} setFolderId={setFolderId} />
      <div className="flex justify-end mx-5 my-3 gap-3">
        <button
          onClick={closeModal}
          className="border border-red-500 bg-red-500 text-white p-1 px-5 rounded-lg"
        >
          Cancel
        </button>
        <button
          className="border border-red-500 bg-red-700 text-white p-1 px-5 rounded-lg"
          onClick={updateFolders}
        >
          Copy
        </button>
      </div>
    </Modal>
  );
};

export default CopyProcedureModal;
